<div class="d-block">
  <div class="modal-body pb-0">
    <div class="d-flex justify-content-end" (click)="cancel()">
      <img src="assets/images/close_icon.svg" alt="Close">
    </div>
    <div class="social-title mb-2">
      {{ title | translate}}
    </div>
    <div class="confirm-body">
      {{ message | translate}}
    </div>

  </div>
  <div class="confirm-footer">
    <button type="button" class="btn common-btn" (click)="cancel()">{{ cancelText | translate }}</button>
    <button type="button" class="btn common-btn" (click)="confirm()">{{ confirmText | translate }}</button>
  </div>
</div>